import { render } from "./MainMenuView.vue?vue&type=template&id=949e8142&scoped=true"
import script from "./MainMenuView.vue?vue&type=script&lang=js"
export * from "./MainMenuView.vue?vue&type=script&lang=js"

import "./MainMenuView.vue?vue&type=style&index=0&id=949e8142&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-949e8142"]])

export default __exports__